import React from 'react'
import { Grid, Typography } from '@mui/material'
import { Autocomplete, ConfirmDialog, TextField } from '@carsys/ui'
import useQuery from '@cbgms/base/http/use-query'
import { loadConversionSnapshots } from 'app-support/shops/state/actions'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { LoadingButton } from '@mui/lab'
import { runConversionForShop } from '../state/actions'
import { useHistory } from 'react-router-dom'

interface StartConversionFormProps {
  shopID: string
  companyUUID: string
}

const StartConversionForm = ({ shopID, companyUUID }: StartConversionFormProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  const [cssShopID, setCSSShopID] = React.useState<string | null>(null)
  const [cssTimestamp, setCSSTimestamp] = React.useState<string | null>(null)
  const [startConfirmDialogOpen, setStartConfirmDialogOpen] = React.useState(false)

  const conversionSnapshotsQuery = useQuery(['css-conversion-snapshots'], async () => {
    return (await dispatch(loadConversionSnapshots())).Data
  })
  const getConversionShopIDs = () => {
    if (!conversionSnapshotsQuery.data) return []
    return conversionSnapshotsQuery.data.map(s => s.CSSShopID)
  }
  const getConversionTimestamps = () => {
    if (!cssShopID) return []
    const timestamps = conversionSnapshotsQuery.data?.find(s => s.CSSShopID === cssShopID)?.Timestamps
    return timestamps ?? []
  }

  const canSubmit = !!cssShopID && cssShopID.length > 0 && !!cssTimestamp && cssTimestamp.length > 0

  const runConversion = async () => {
    if (!canSubmit) return

    await dispatch(
      runConversionForShop({
        CSSShopID: cssShopID,
        CSSTimestamp: cssTimestamp,
        ShopID: shopID,
        CompanyUUID: companyUUID
      })
    )

    history.push('/conversion')
  }

  return (
    <>
      <Grid container item spacing={1}>
        <Grid item xs={12}>
          <Typography variant='h5'>{t('conversion.title')}</Typography>
        </Grid>
        <Grid item xs={2}>
          <Autocomplete
            options={getConversionShopIDs()}
            fullWidth
            value={cssShopID}
            onChange={(_, val) => setCSSShopID(val)}
            renderInput={params => <TextField {...params} label={t('conversion.css_shop_id')} />}
          />
        </Grid>
        <Grid item xs={2}>
          <Autocomplete
            options={getConversionTimestamps()}
            fullWidth
            value={cssTimestamp}
            onChange={(_, val) => setCSSTimestamp(val)}
            renderInput={params => <TextField {...params} label={t('conversion.css_timestamp')} />}
          />
        </Grid>
        <Grid item xs={2}>
          <LoadingButton onClick={() => setStartConfirmDialogOpen(true)} variant='outlined' disabled={!canSubmit}>
            {t('global.add_conversion')}
          </LoadingButton>
        </Grid>
      </Grid>
      <ConfirmDialog
        open={startConfirmDialogOpen}
        onClose={() => setStartConfirmDialogOpen(false)}
        onConfirm={runConversion}
        content={t('conversion.confirm_content')}
        cancelButtonContent={t('global.cancel')}
        confirmButtonContent={t('global.confirm')}
      />
    </>
  )
}

export default StartConversionForm
